import {
  List, Datagrid, TextField, EditButton, Edit, Create, SimpleForm,
  TextInput, SelectInput, NumberInput, required,
} from 'react-admin';
import { Stack } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const KINDS = [
  { id: 'testing_centre', name: 'Testing centre' },
  { id: 'board_venue', name: 'Board exam venue' },
  { id: 'admission_office_1', name: 'Admission office 1' },
  { id: 'admission_office_2', name: 'Admission office 2' },
];

const AddressList = () => (
  <List sort={{ field: 'sortOrder', order: 'ASC' }} perPage={25}>
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField source="title" />
      <TextField source="kind" />
      <TextField source="mobile" />
      <TextField source="email" />
      <EditButton />
    </Datagrid>
  </List>
);

const AddressForm = () => (
  <Stack spacing={2} sx={{ maxWidth: 720 }}>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <SelectInput source="kind" choices={KINDS} validate={required()} sx={{ minWidth: 240 }} />
      <TextInput source="title" validate={required()} fullWidth />
    </Stack>
    <TextInput source="addressLine" multiline minRows={2} fullWidth />
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextInput source="mobile" fullWidth />
      <TextInput source="email" fullWidth />
      <TextInput source="fax" fullWidth />
    </Stack>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextInput source="web" fullWidth />
      <TextInput source="portal" fullWidth />
    </Stack>
    <NumberInput source="sortOrder" defaultValue={0} />
  </Stack>
);

const AddressEdit = () => (
  <Edit redirect="list" mutationMode="pessimistic">
    <SimpleForm><AddressForm /></SimpleForm>
  </Edit>
);
const AddressCreate = () => (
  <Create redirect="list">
    <SimpleForm><AddressForm /></SimpleForm>
  </Create>
);

export default {
  list: AddressList,
  edit: AddressEdit,
  // The schema fixes 4 kinds, but we still expose Create so editors can
  // re-add a row if one is accidentally deleted via raw SQL. Delete is
  // disabled on the API side.
  create: AddressCreate,
  icon: LocationOnIcon,
  options: { label: 'Addresses' },
  recordRepresentation: 'title',
};
